import { useCallback } from "react";
import PlusIcon from "@heroicons/react/24/solid/PlusIcon";
import { Button, SvgIcon } from "@mui/material";
import { Link } from "react-router-dom";
import { useSelector } from "react-redux";
import EntityListPage from "../../common/crud/EntityListPage";
import { CustomersTable } from "../../components/Users/customers-table";
import { CustomersSearch } from "../../components/Users/customers-search";
import useUser from "../../hooks/store/user";

const Page = () => {
  const {
    Data,
    noOfRecords,
    rowsPerPage,
    page,
    loading,
    setPageNumberAction,
    setRowsPerPageAction,
  } = useUser();
  const colorSet = useSelector((state) => state.color);

  const handlePageChange = useCallback(
    (_, value) => {
      setPageNumberAction(value);
    },
    [setPageNumberAction]
  );

  const handleRowsPerPageChange = useCallback(
    (event) => {
      setRowsPerPageAction(event.target.value);
      setPageNumberAction(0);
    },
    [setPageNumberAction, setRowsPerPageAction]
  );

  return (
    <EntityListPage
      headerAction={
        <Button
          component={Link}
          startIcon={
            <SvgIcon fontSize="small">
              <PlusIcon />
            </SvgIcon>
          }
          sx={{
            backgroundColor: colorSet.color,
            ":hover": { backgroundColor: colorSet.color },
            color: "white",
          }}
          to="/add/users"
          variant="contained"
        >
          Add
        </Button>
      }
      loading={loading}
      search={<CustomersSearch />}
      table={
        <CustomersTable
          count={noOfRecords}
          items={Data}
          onPageChange={handlePageChange}
          onRowsPerPageChange={handleRowsPerPageChange}
          page={page}
          rowsPerPage={rowsPerPage}
        />
      }
      title="Users"
    />
  );
};

export default Page;
